module.exports = __webpack_public_path__ + "static/media/motor-policy-type.b32f33fd.svg";